var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "sui-table",
        { attrs: { selectable: "" } },
        [
          _c(
            "sui-table-header",
            [
              _c(
                "sui-table-row",
                [
                  _c("sui-table-header-cell"),
                  _vm._l(_vm.columns, function (column, index) {
                    return _c("sui-table-header-cell", { key: index }, [
                      _vm._v(" " + _vm._s(column) + " "),
                    ])
                  }),
                  _c("sui-table-header-cell"),
                ],
                2
              ),
            ],
            1
          ),
          _vm.models
            ? _c(
                "sui-table-body",
                _vm._l(_vm.models, function (model, index) {
                  return _c(
                    "sui-table-row",
                    { key: model.id },
                    [
                      _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                        _vm._v(_vm._s(index + 1)),
                      ]),
                      _c("sui-table-cell", [
                        _c(
                          "div",
                          {
                            staticClass: "model-name",
                            on: {
                              click: function ($event) {
                                return _vm.edit(model.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(model.investment_model_name) + " "
                            ),
                          ]
                        ),
                      ]),
                      _c("sui-table-cell", [_vm._v(_vm._s(model.firm_name))]),
                      _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                        _vm._v(_vm._s(_vm.toDatetime(model.created_date))),
                      ]),
                      _c("sui-table-cell", [
                        _vm._v(
                          _vm._s(_vm.toDatetime(model.last_modified_date))
                        ),
                      ]),
                      _c("sui-table-cell", [
                        _c("div", { staticClass: "table-row-menu" }, [
                          _c(
                            "div",
                            { staticClass: "action-icons" },
                            [
                              _c("sui-icon", {
                                staticClass: "edit-icon",
                                attrs: { name: "edit" },
                                on: {
                                  click: function ($event) {
                                    return _vm.edit(model.id)
                                  },
                                },
                              }),
                              _c("sui-icon", {
                                staticClass: "trash-icon",
                                attrs: { name: "trash" },
                                on: {
                                  click: function ($event) {
                                    return _vm.remove(model)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ],
                    1
                  )
                }),
                1
              )
            : _c("div", [_c("p", [_vm._v("Not firm models found.")])]),
        ],
        1
      ),
      _vm.models.length === 0 ? _c("NoItemsFoundListMessage") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }